module.exports = __webpack_public_path__ + "img/logo2.1465561b.png";